import { Layers, ChevronDown, BookOpenCheck } from "lucide-react";
import { HighlightComponentProps } from "../highlights";

export const FlashcardsPreview: React.FC<HighlightComponentProps> = ({
  result,
  isExpanded = false,
  onToggleExpand,
}) => {
  const { contents } = result;
  const flashcards = (contents as any)?.flashcards ?? [];

  const PREVIEW_COUNT = 3;
  const visible = isExpanded ? flashcards : flashcards.slice(0, PREVIEW_COUNT);

  return (
    <div className="space-y-2">
      {/* Cards */}
      <div className="space-y-2">
        {visible.map((card: any, i: number) => (
          <div
            key={i}
            className="rounded-lg border border-theme bg-theme-1 px-3 py-2.5 hover:border-theme hover:bg-theme-1 transition-colors"
          >
            <div className="flex items-start gap-2.5">
              {/* Index badge */}
              <div className="mt-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-slate-700 text-[11px] font-bold text-white flex-shrink-0">
                {i + 1}
              </div>

              <div className="flex-1 min-w-0">
                {/* Term */}
                <div className="text-[13px] font-semibold leading-snug text-theme-0 mb-1">
                  {card.term}
                </div>

                {/* Definition preview */}
                <div className="text-[11px] leading-snug text-theme-1 line-clamp-2">
                  {card.definition}
                </div>
              </div>
            </div>

            {/* Hint row */}
            <div className="mt-2 pt-2 border-t border-theme flex items-center gap-1.5 text-[10px] text-theme-1 font-medium">
              <BookOpenCheck className="h-3 w-3 text-indigo-500" />
              Term & definition included
            </div>
          </div>
        ))}
      </div>

      {/* Expand affordance */}
      {!isExpanded && flashcards.length > PREVIEW_COUNT && (
        <button
          onClick={onToggleExpand}
          className="w-full flex items-center justify-center gap-1.5 py-2 text-[11px] font-semibold text-theme-2 hover:text-theme-0 transition-colors rounded-lg hover:bg-theme-1"
        >
          <span>View all {flashcards.length} flashcards</span>
          <ChevronDown className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
};
